export var MARITAL_STATUSES;
(function (MARITAL_STATUSES) {
    MARITAL_STATUSES["MARRIED"] = "MARRIED";
    MARITAL_STATUSES["PARTNERSHIP"] = "PARTNERSHIP";
    MARITAL_STATUSES["SEPARATED"] = "SEPARATED";
    MARITAL_STATUSES["DIVORCED"] = "DIVORCED";
})(MARITAL_STATUSES || (MARITAL_STATUSES = {}));
